import React from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Text } from 'recharts'
import { gasDetecorMetadata } from 'Shared/constant'

const w = 150
const h = 120

const RADIAN = Math.PI / 180
const cx = w/2
const cy = h/2
const iR = 25
const oR = 50
const labelRadius = oR + 15

const needle = (value, data, color) => {
  let total = 0

  data.forEach((v) => {
    total += v.value
  })

  const ang = 240 * (1 - value / total) - 30
  const length = (iR + 2 * oR) / 3
  const sin = Math.sin(-RADIAN * ang)
  const cos = Math.cos(-RADIAN * ang)
  const r = 5
  const x0 = cx
  const y0 = cy + 15
  const xba = x0 + r * sin
  const yba = y0 - r * cos
  const xbb = x0 - r * sin
  const ybb = y0 + r * cos
  const xp = x0 + length * cos
  const yp = y0 + length * sin

  return [
    <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
    <path d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={color} />,
  ]
}

const color = ["#008000", "#FFA500", "#FF0000"]

const GasVault = ({ data, type, value, label, unit, alert }) => { 
  const flattened = [0, ...(data.map((i) => i["value"]).reduce((acc, curr) => [...acc, (acc[acc.length - 1] || 0) + curr], []))]
  const max = flattened.slice(-1)[0]
  const min = 0

  const offset = 15

  const calculateLabelPosition = (tickValue) => {
    const percentage = (tickValue - min) / (max - min)
    const angle = 210 - (240 * percentage)
    const angleRad = angle * RADIAN
    
    const x = cx + labelRadius * Math.cos(angleRad)
    const y = cy - labelRadius * Math.sin(angleRad) + offset
    
    return { x, y }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ width: `${w}px`, height: `${h}px` }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: offset, left: 0, right: 60, bottom: 0 }}>
            <Pie
              dataKey="value"
              startAngle={180+30}
              endAngle={0-30}
              data={data}
              cx={cx}
              cy={cy}
              innerRadius={iR}
              outerRadius={oR}
              paddingAngle={0}
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>

            {flattened.map((tick, index) => {
              const { x, y } = calculateLabelPosition(tick)

              return (
                <Text
                  key={index}
                  x={x}
                  y={y}
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize="12"
                  fill="#666"
                >
                  {Math.round(tick)}
                </Text>
              )
            })}

            {(value != null) && <>
              {needle(Math.min(Math.max(value, gasDetecorMetadata[type]["plotRange"][0]), gasDetecorMetadata[type]["plotRange"][1]), data, '#808080')}
            </>}
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div style={{ color: (value != null) ? color[alert] : "#000000", marginTop: "-10px" }}>{`${label}: ${(value != null) ? `${value} ${unit}` : "-"}`}</div>
    </div>
  )
}

export default GasVault
